<template>
  <div
    class="mobile-menu__topics-wrapper"
    :style="
      `background-image: url(${getCategoryDetails(category.name).background})`
    "
    v-if="currentCategory === category.name"
  >
    <ul
      v-if="getCategoryDetails(category.name).topics.length"
      class="mobile-menu__topics"
    >
      <li
        class="mobile-menu__topic"
        v-for="(topic, idx) in getCategoryDetails(category.name).topics"
        :key="`mobile-topic-${idx}`"
        @click="openCategorySearch(topic)"
      >
        {{ topic.name }}
      </li>
    </ul>
    <div class="mobile-menu__view-all-wrapper">
      <router-link
        class="mobile-menu__view-all"
        @click.native="$emit('closeMegaMenu')"
        :to="{ name: 'learning-area', params: { id: category.id } }"
      >
        View All
        <span class="mega-menu__arrow material-icons"
          >keyboard_arrow_right</span
        >
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Topics',
  props: {
    category: {
      type: Object,
      required: true,
    },
    getCategoryDetails: {
      type: Function,
      required: true,
    },
    currentCategory: {
      type: String,
      required: true,
    },
    openCategorySearch: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
$mobile: 320px;
$tablet: 769px;
$desktop: 1024px;
$lg_desktop: 1300px;
.mobile-menu {
  $this: &;
  &__topics-wrapper {
    border-bottom: 1px solid #222;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }
  &__topics {
    padding: 15px 0 0;
    margin: 0;
    list-style-type: none;
  }
  &__topic {
    padding: 10px 10px 10px 80px;
  }
  &__view-all-wrapper {
    padding: 30px 0;
  }
  &__view-all {
    background: #222;
    text-transform: uppercase;
    color: var(--white);
    padding: 8px 15px;
    line-height: 1;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    font-size: (14 / 16) * 1rem;
    margin: 0 0 0 80px;
  }
}
</style>
